export type DocumentType = 'cpf' | 'cnpj'

const CPF_PATTERN = /^\d{11}$/
const CNPJ_PATTERN = /^[0-9A-Z]{12}\d{2}$/

export const normalizeDocument = (value?: string | null): string => (value ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '')

export const isCpfShape = (value?: string | null): boolean => CPF_PATTERN.test(normalizeDocument(value))

export const isCnpjShape = (value?: string | null): boolean => CNPJ_PATTERN.test(normalizeDocument(value))

export function documentTypeOf(value?: string | null): DocumentType | null {
  if (isCpfShape(value)) return 'cpf'
  if (isCnpjShape(value)) return 'cnpj'
  return null
}

function cnpjCheckDigit(base: string): number {
  let sum = 0
  let weight = 2
  for (let i = base.length - 1; i >= 0; i--) {
    sum += (base.charCodeAt(i) - 48) * weight
    weight = weight === 9 ? 2 : weight + 1
  }
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

export function isValidCnpj(value?: string | null): boolean {
  const cnpj = normalizeDocument(value)
  if (!CNPJ_PATTERN.test(cnpj) || /^(.)\1+$/.test(cnpj)) return false
  const base = cnpj.slice(0, 12)
  const first = cnpjCheckDigit(base)
  const second = cnpjCheckDigit(`${base}${first}`)
  return cnpj.endsWith(`${first}${second}`)
}

export function maskCnpj(value?: string | null): string {
  const raw = normalizeDocument(value)
  const chars = `${raw.slice(0, 12)}${raw.slice(12).replace(/\D/g, '').slice(0, 2)}`
  let masked = chars.slice(0, 2)
  if (chars.length > 2) masked += `.${chars.slice(2, 5)}`
  if (chars.length > 5) masked += `.${chars.slice(5, 8)}`
  if (chars.length > 8) masked += `/${chars.slice(8, 12)}`
  if (chars.length > 12) masked += `-${chars.slice(12, 14)}`
  return masked
}
